import React from "react";
import PropTypes from "prop-types";
import { useDispatch, useSelector } from "react-redux";
import Dropdown from "./Dropdown";
import UpdateButtons from "./UpdateButtons";
import DatePicker from "./DatePicker";
import ToggleableButton from "../../../../components/toggleableButton/toggleableButton";
import MultiSelectDropdown from "../../../../components/multiSelectDropdown/multiSelectDropdown";
import LoadingAnimation from "../../../../components/loadingAnimation/loadingAnimation";

// TODO: place css from attendance
const DateFilters = ({ moduleName, actionCreators }) => {
  const dispatch = useDispatch();
  const { updateFilters, updateReferralToggle, updateData, fetchData } = actionCreators;

  const {
    availableFilters,
    filters: {
      referralCategories,
      referralValues,
      rangeValue,
      rangeOptions,
      filtersDirty,
      periodType,
      periodTypes,
      referralCategory
    },
    filters,
    isFiltersLoading
  } = useSelector((state) => state[moduleName]);

  return (
    <div id="override-edit-selection-bar" className="edit-selections-bar">
      <div className="top-filter">
        <div>
          <div className="referral-category-wrapper">
            {availableFilters.includes("referral_categories") && (
              <div className="select-box-no-width" style={{ width: "140px" }}>
                <p>{referralCategory ? "Referral Categories" : "Referral Source"}</p>
                {isFiltersLoading ? (
                  <LoadingAnimation uiLoader />
                ) : (
                  <MultiSelectDropdown
                    options={referralCategories}
                    selectedFilters={referralValues}
                    height="350px"
                    numberDisplayed={0}
                    enableOnly
                    includeSelectAll
                    onSelectChange={(newValues) =>
                      dispatch(updateFilters({ moduleName, referralValues: newValues }))
                    }
                  />
                )}
              </div>
            )}
            {availableFilters.includes("referral_category") && (
              <div className="select-box-no-width">
                <p>Referral Category</p>
                <ToggleableButton
                  isRadio
                  isActive={referralCategory}
                  title={moduleName + "referal-category"}
                  onClick={(toggleValue) =>
                    dispatch(
                      updateReferralToggle({
                        moduleName,
                        referralCategory: toggleValue,
                        willUpdateFilters: true,
                        filters
                      })
                    )
                  }
                />
              </div>
            )}
          </div>
        </div>
        <div className="top-filter__right">
          {availableFilters.includes("period") && (
            <Dropdown
              title="Period Type"
              options={periodTypes}
              value={periodType?.capitalize()}
              onChange={(newValue) =>
                newValue !== periodType?.capitalize() &&
                dispatch(updateFilters({ moduleName, periodType: newValue }))
              }
            />
          )}
          {availableFilters.includes("date_range") && (
            <Dropdown
              title="Date Range"
              classNames="date-range-select-box"
              options={rangeOptions}
              value={rangeValue}
              onChange={(newValue) => {
                const { startDate, endDate } = newValue;
                newValue?.id !== rangeValue?.id &&
                  dispatch(
                    updateFilters({
                      moduleName,
                      startDate,
                      endDate,
                      rangeValue: newValue
                    })
                  );
              }}
            />
          )}

          {availableFilters.includes("date") && (
            <DatePicker
              moduleName={moduleName}
              monthly={availableFilters.includes("monthly_picker")}
              updateFilters={updateFilters}
            />
          )}

          {/* Update and Reset Buttons */}
          {filtersDirty && (
            <UpdateButtons moduleName={moduleName} updateData={updateData} fetchData={fetchData} />
          )}
        </div>
      </div>
    </div>
  );
};

DateFilters.propTypes = { moduleName: PropTypes.string };

export default DateFilters;
